"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RateCardRateBase = exports.RateCardTermType = exports.RateCardEntityType = void 0;
var RateCardEntityType;
(function (RateCardEntityType) {
    RateCardEntityType["Fleet"] = "fleet";
    RateCardEntityType["DeliveryProvider"] = "delivery_provider";
})(RateCardEntityType || (exports.RateCardEntityType = RateCardEntityType = {}));
var RateCardTermType;
(function (RateCardTermType) {
    RateCardTermType["Base"] = "base";
    RateCardTermType["Surcharge"] = "surcharge";
})(RateCardTermType || (exports.RateCardTermType = RateCardTermType = {}));
var RateCardRateBase;
(function (RateCardRateBase) {
    RateCardRateBase["Flat"] = "flat";
    RateCardRateBase["Units"] = "units";
    RateCardRateBase["Miles"] = "miles";
    RateCardRateBase["Weight"] = "weight";
})(RateCardRateBase || (exports.RateCardRateBase = RateCardRateBase = {}));
//# sourceMappingURL=rate_card.js.map